import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SettingsProvider } from './context/SettingsContext';
import { useSEO } from "./hooks/useSEO";

// --- LAYOUTS ---
import MainLayout from "./layouts/MainLayout";
import ProtectedRoute from "./layouts/ProtectedRoute"; // Layout keamanan baru

// --- PAGES ---
import LoginPage from "./pages/auth/LoginPage";
import RegisterPage from "./pages/auth/RegisterPage";
import Hero from "./components/LandingPage/Hero";
import LandingPageIndex from "./pages/landing-page/Index";
import SpeakersPageIndex from "./pages/speaker/Index";
import VenuesPageIndex from "./pages/venue/Index";
import Admin from "./pages/admin/Index";

function App() {
  // Mengaktifkan SEO Hook
  useSEO();

  return (
    <Router>
      <SettingsProvider>
        <Routes>
          {/* GROUP 1: Public Routes (Menggunakan MainLayout dengan Navbar & Footer) */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={
              <>
                <section id="home" className="scroll-mt-32">
                  <Hero />
                </section>
                <LandingPageIndex />
              </>
            } />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
            <Route path="speakers" element={<SpeakersPageIndex />} />
            <Route path="venues" element={<VenuesPageIndex />} />
          </Route>

          {/* GROUP 2: Protected Admin Routes (Tanpa Navbar & Footer Landing Page) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/admin" element={<Admin />} />
            {/* Anda bisa menambah rute admin lain di bawah sini jika perlu */}
          </Route>

          {/* 404 Page */}
          <Route path="*" element={
            <div className="flex h-screen items-center justify-center text-2xl font-black uppercase tracking-widest text-slate-400">
              404 | Page Not Found
            </div>
          } />
        </Routes>
      </SettingsProvider>
    </Router>
  );
}

export default App;